import { Group } from './group';
/**
 * The GroupY transform group data by x channel, and aggregate.
 */
export const GroupY = (options = {}) => {
    return Group(Object.assign(Object.assign({}, options), { channels: ['y', 'color', 'series'] }));
};
GroupY.props = {};
//# sourceMappingURL=groupY.js.map